import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap/lib/Modal'
import ControlLabel from 'react-bootstrap/lib/ControlLabel'
import Button from 'react-bootstrap/lib/Button'
import FormGroup from 'react-bootstrap/lib/FormGroup'
import FormControl from 'react-bootstrap/lib/FormControl'
import HelpBlock from 'react-bootstrap/lib/HelpBlock'
import Grid from 'react-bootstrap/lib/Grid'
import Row from 'react-bootstrap/lib/Row'
import Col from 'react-bootstrap/lib/Col'
import Image from 'react-bootstrap/lib/Image'

import { closeAttendeesModal } from '../actions/attendees.js'
import { requireAccess } from '../actions/auth.js'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

class Attendees extends Component {
  static defaultProps = {}

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  closeAttendeesModal() {
    const { dispatch } = this.props
    dispatch(closeAttendeesModal())
  }

  render() {
    return (
      <div style={{ height: 120, width: 200 }}>
        <Modal show={this.props.showAttendeesModal} onHide={this.closeAttendeesModal.bind(this)}>
          <Modal.Header closeButton={true}>
            <div className='text-center'>
              <h4>Attendees</h4>
            </div>
          </Modal.Header>
          <Modal.Body>
            {this.props.attendees && this.props.attendees.length > 0 ? (
              <div>
                <Grid>
                  {this.props.attendees.map(attendee => {
                    return (
                      <Row>
                        <Col>
                          <div className='attendeeCircle' style={{ margin: '10px', padding: '0px' }}>
                            <span>
                              {attendee.image ? (
                                <Image
                                  thumbnail
                                  src={attendee.image}
                                  onError={e => (e.target.src = '../images/guestAvatar.png')}
                                  circle
                                  style={{ padding: '0px' }}
                                />
                              ) : (
                                <Image src='/images/guestAvatar.png' circle thumbnail style={{ padding: '0px' }} />
                              )}
                            </span>
                          </div>
                        </Col>
                        <Col>
                          <div>
                            <h4 style={{ marginTop: '23px' }}>{attendee.fullName || attendee.invitation}</h4>
                          </div>
                        </Col>
                      </Row>
                    )
                  })}
                </Grid>
              </div>
            ) : (
              <div className='text-center'>
                <h4>No Attendees</h4>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </div>
    )
  }
}
const mapStateToProps = state => {
  return state.attendeesReducer
}

export default withRouter(connect(mapStateToProps)(Attendees))



// WEBPACK FOOTER //
// ./src/components/Attendees.js